var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { LoadingAFY, position, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { usePlanCreation } from "./hook/planCreation.hook";
import { PlanCreationView } from "./view/planCreation.view";
import { LOADING_TEXT } from "./constants/planCreation.constants";
import "./style/planCreation.css";
export var PlanCreation = function () {
    var planCreation = usePlanCreation();
    return (_jsxs(React.Fragment, { children: [planCreation.seeToast.show &&
                showToast(position.topRight, planCreation.seeToast.type, planCreation.seeToast.message, planCreation.closeToast), _jsx(LoadingAFY, { loading: planCreation.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: LOADING_TEXT, textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(PlanCreationView, __assign({}, planCreation.view))] }));
};
export default PlanCreation;
